var lockCount = 0;
export function lockClick(lock) {
  if (lock) {
    if (!lockCount) {
      document.body.classList.add('van-toast--unclickable');
    }

    lockCount++;
  } else {
    lockCount--;

    if (!lockCount) {
      document.body.classList.remove('van-toast--unclickable');
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/toast/lock-click.js
// module id = 387
// module chunks = 31